"use client";

import { c as _c } from "react/compiler-runtime";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import DotLoader from "@/components/dotLoader/DotLoader";
import { displayedEonNumberFromIndex, displayedEpochNumberFromIndex, displayedEraNumberFromIndex, displayedPeriodNumberFromIndex, displayedSeasonNumberFromIndex, displayedYearNumberFromIndex, getCardsRemainingUntilEndOf, getSeasonIndexForDate, nextMintDateOnOrAfter } from "@/components/meme-calendar/meme-calendar.helpers";
import ShowMoreButton from "@/components/show-more-button/ShowMoreButton";
import { MEMES_MINT_PRICE, SUBSCRIPTIONS_ADDRESS, SUBSCRIPTIONS_ADDRESS_ENS, SUBSCRIPTIONS_CHAIN } from "@/constants";
import { formatAddress, getTransactionLink, numberWithCommasFromString } from "@/helpers/Helpers";
import useCapacitor from "@/hooks/useCapacitor";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import { parseEther } from "viem";
import { useSendTransaction, useWaitForTransactionReceipt } from "wagmi";
import styles from "./UserPageSubscriptions.module.scss";
export default function UserPageSubscriptionsTopUp() {
  const $ = _c(75);
  const {
    isIos
  } = useCapacitor();
  const {
    country
  } = useCookieConsent();
  const [memeCount, setMemeCount] = useState("");
  const sendTransaction = useSendTransaction();
  const nextMintDate = nextMintDateOnOrAfter();
  const idx = getSeasonIndexForDate(nextMintDate);
  const szn = displayedSeasonNumberFromIndex(idx);
  const year = displayedYearNumberFromIndex(idx);
  const epoch = displayedEpochNumberFromIndex(idx);
  const period = displayedPeriodNumberFromIndex(idx);
  const era = displayedEraNumberFromIndex(idx);
  const eon = displayedEonNumberFromIndex(idx);
  const {
    isConnected
  } = useSeizeConnectContext();
  const remainingMintsForSeason = getCardsRemainingUntilEndOf("szn");
  const remainingMintsForYear = getCardsRemainingUntilEndOf("year");
  const remainingMintsForEpoch = getCardsRemainingUntilEndOf("epoch");
  const remainingMintsForPeriod = getCardsRemainingUntilEndOf("period");
  const remainingMintsForEra = getCardsRemainingUntilEndOf("era");
  const remainingMintsForEon = getCardsRemainingUntilEndOf("eon");
  let t0;
  if ($[0] !== sendTransaction.data) {
    t0 = {
      chainId: SUBSCRIPTIONS_CHAIN.id,
      confirmations: 1,
      hash: sendTransaction.data
    };
    $[0] = sendTransaction.data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const waitSendTransaction = useWaitForTransactionReceipt(t0);
  const [error, setError] = useState("");
  const [showDeep, setShowDeep] = useState(false);
  let t1;
  if ($[2] !== isConnected || $[3] !== sendTransaction) {
    t1 = function submit(value) {
      setError("");
      if (isNaN(value)) {
        setError("Select card count");
        return;
      }
      if (!isConnected) {
        setError("You must have an active wallet connection to top up");
        return;
      }
      sendTransaction.reset();
      sendTransaction.sendTransaction({
        chainId: SUBSCRIPTIONS_CHAIN.id,
        to: SUBSCRIPTIONS_ADDRESS,
        value: parseEther(value.toString())
      });
    };
    $[2] = isConnected;
    $[3] = sendTransaction;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const submit = t1;
  let t2;
  let t3;
  if ($[5] !== sendTransaction.error) {
    t2 = () => {
      if (sendTransaction.error) {
        const errorMsg = sendTransaction.error.message.split("Request Arguments")[0];
        setError(`Error - ${errorMsg}`);
      }
    };
    t3 = [sendTransaction.error];
    $[5] = sendTransaction.error;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== waitSendTransaction.isLoading || $[9] !== waitSendTransaction.isSuccess) {
    t4 = function getStatusMessage() {
      if (waitSendTransaction.isLoading) {
        return "Transaction Submitted";
      } else {
        if (waitSendTransaction.isSuccess) {
          return "Top Up Successful!";
        } else {
          return "Something went wrong";
        }
      }
    };
    $[8] = waitSendTransaction.isLoading;
    $[9] = waitSendTransaction.isSuccess;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const getStatusMessage = t4;
  let t5;
  if ($[11] !== error || $[12] !== getStatusMessage || $[13] !== sendTransaction.data || $[14] !== sendTransaction.isPending) {
    t5 = function getMessage() {
      if (error) {
        return error;
      }
      if (sendTransaction.isPending) {
        return "Confirming Transaction...";
      }
      if (sendTransaction.data) {
        return <>{getStatusMessage()}{" "}<a href={getTransactionLink(SUBSCRIPTIONS_CHAIN.id, sendTransaction.data)} target="_blank" rel="noopener noreferrer">view</a></>;
      }
      return <> </>;
    };
    $[11] = error;
    $[12] = getStatusMessage;
    $[13] = sendTransaction.data;
    $[14] = sendTransaction.isPending;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const getMessage = t5;
  if (isIos && country !== "US") {
    let t6;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <></>;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    return t6;
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Row className="pt-2"><Col><Link href={window.location.href} className="text-center pt-2 pb-2" target="_blank" rel="noopener noreferrer"><button className="btn btn-light" style={{
            width: "100%"
          }}>Top-up on 6529.io</button></Link></Col></Row>;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const iOsContent = t6;
  let t7;
  if ($[18] !== sendTransaction.isPending || $[19] !== submit || $[20] !== waitSendTransaction.isLoading) {
    t7 = (count, label, value_0) => {
      if (count > 0) {
        return <Row className="pt-3"><Col><CardCountTopup count={count} display={`Remaining ${label} ${value_0.toLocaleString()}`} disabled={sendTransaction.isPending || waitSendTransaction.isLoading} submit={value_1 => {
              submit(value_1);
            }} /></Col></Row>;
      }
      return null;
    };
    $[18] = sendTransaction.isPending;
    $[19] = submit;
    $[20] = waitSendTransaction.isLoading;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const printRemainingMints = t7;
  const t8 = sendTransaction.isPending || waitSendTransaction.isLoading;
  let t9;
  if ($[22] !== submit) {
    t9 = value_2 => {
      submit(value_2);
    };
    $[22] = submit;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = <Row className="pt-2"><Col><CardCountTopup count={1} disabled={t8} submit={t9} /></Col></Row>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const t11 = printRemainingMints(remainingMintsForSeason, "SZN", szn);
  const t12 = printRemainingMints(remainingMintsForYear, "Year", year);
  const t13 = printRemainingMints(remainingMintsForEpoch, "Epoch", epoch);
  let t14;
  if ($[27] !== memeCount || $[28] !== submit) {
    t14 = e => {
      e.preventDefault();
      const count_0 = parseInt(memeCount);
      if (isNaN(count_0) || count_0 < 1) {
        setError("Enter a valid count");
      } else {
        submit(count_0 * MEMES_MINT_PRICE);
      }
    };
    $[27] = memeCount;
    $[28] = submit;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span>Other</span>;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      width: "100px",
      padding: "2px 10px"
    };
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = e_0 => {
      setError("");
      const value_3 = e_0.target.value;
      try {
        parseInt(value_3);
        setMemeCount(value_3);
      } catch {
        setMemeCount("");
      }
    };
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== memeCount) {
    t18 = <Form.Control type="number" min={1} placeholder="count" value={memeCount} style={t16} className="font-smaller" onChange={t17} />;
    $[33] = memeCount;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== memeCount) {
    t19 = !isNaN(parseInt(memeCount)) && <>({parseInt(memeCount) * MEMES_MINT_PRICE} ETH)</>;
    $[35] = memeCount;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t19) {
    t20 = <span className="no-wrap">{t19}</span>;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t18 || $[40] !== t20) {
    t21 = <Col xs={9} sm={8} className="d-flex align-items-center gap-2">{t15}{t18}{t20}</Col>;
    $[39] = t18;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  const t22 = sendTransaction.isPending || waitSendTransaction.isLoading;
  let t23;
  if ($[42] !== t22) {
    t23 = <Col xs={3} sm={4}><Button className={styles.sendBtn} type="submit" aria-label="Send custom top up" disabled={t22}>Send</Button></Col>;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t21 || $[45] !== t23) {
    t24 = <Form.Group><Row className="d-flex align-items-center">{t21}{t23}</Row></Form.Group>;
    $[44] = t21;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t14 || $[48] !== t24) {
    t25 = <Row className="pt-3"><Col><Form onSubmit={t14}>{t24}</Form></Col></Row>;
    $[47] = t14;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  const t26 = showDeep && <>{printRemainingMints(remainingMintsForPeriod, "Period", period)}{printRemainingMints(remainingMintsForEra, "Era", era)}{printRemainingMints(remainingMintsForEon, "Eon", eon)}</>;
  let t27;
  if ($[50] !== setShowDeep || $[51] !== showDeep) {
    t27 = <Row className="pt-3 pb-4"><Col><ShowMoreButton expanded={showDeep} setExpanded={setShowDeep} showMoreLabel="Show Deep Time Subscriptions" showLessLabel="Hide Deep Time Subscriptions" /></Col></Row>;
    $[50] = setShowDeep;
    $[51] = showDeep;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  const t28 = `d-flex align-items-center gap-2 tw-font-medium ${error ? "tw-text-red" : ""}`;
  let t29;
  if ($[53] !== getMessage) {
    t29 = getMessage();
    $[53] = getMessage;
    $[54] = t29;
  } else {
    t29 = $[54];
  }
  let t30;
  if ($[55] !== t28 || $[56] !== t29) {
    t30 = <Row><Col className={t28}>{t29}</Col></Row>;
    $[55] = t28;
    $[56] = t29;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] !== waitSendTransaction.isLoading) {
    t31 = waitSendTransaction.isLoading && <Row><Col>Waiting for confirmation <DotLoader /></Col></Row>;
    $[58] = waitSendTransaction.isLoading;
    $[59] = t31;
  } else {
    t31 = $[59];
  }
  let t32;
  if ($[60] !== t10 || $[61] !== t11 || $[62] !== t12 || $[63] !== t13 || $[64] !== t25 || $[65] !== t26 || $[66] !== t27 || $[67] !== t30 || $[68] !== t31) {
    t32 = <>{t10}{t11}{t12}{t13}{t25}{t26}{t27}{t30}{t31}</>;
    $[60] = t10;
    $[61] = t11;
    $[62] = t12;
    $[63] = t13;
    $[64] = t25;
    $[65] = t26;
    $[66] = t27;
    $[67] = t30;
    $[68] = t31;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  const topUpContent = t32;
  let t33;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <h4 className="mb-0">Top Up</h4>;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <span data-tooltip-id="subscription-address">{SUBSCRIPTIONS_ADDRESS_ENS}{" "}{formatAddress(SUBSCRIPTIONS_ADDRESS)}</span>;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  let t35;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Row className="pb-2"><Col className="d-flex align-items-end gap-2 no-wrap">{t33}<span className="d-flex align-items-center gap-1 font-color-h font-smaller">Sending to{" "}<>{t34}<Tooltip id="subscription-address" style={{
              backgroundColor: "#1F2937",
              color: "white",
              padding: "4px 8px"
            }}><span className="font-smaller">{SUBSCRIPTIONS_ADDRESS}</span></Tooltip></></span></Col></Row>;
    $[72] = t35;
  } else {
    t35 = $[72];
  }
  const t36 = isIos ? iOsContent : topUpContent;
  let t37;
  if ($[73] !== t36) {
    t37 = <Container className="no-padding">{t35}{t36}</Container>;
    $[73] = t36;
    $[74] = t37;
  } else {
    t37 = $[74];
  }
  return t37;
}
function CardCountTopup(props) {
  const $ = _c(22);
  let t0;
  if ($[0] !== props) {
    t0 = e => {
      e.preventDefault();
      props.submit(props.count * MEMES_MINT_PRICE);
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.display) {
    t1 = props.display && <span>{props.display} - </span>;
    $[2] = props.display;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.count) {
    t2 = props.count.toLocaleString();
    $[4] = props.count;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = props.count > 1 && "s";
  const t4 = MEMES_MINT_PRICE * props.count;
  let t5;
  if ($[6] !== t4) {
    t5 = numberWithCommasFromString(t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <Col xs={9} sm={8} className="d-flex">{t1}{t2} Card{t3} ({t5} ETH)</Col>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `Send top up for ${props.display ?? `${props.count} Card${props.count > 1 ? "s" : ""}`}`;
  let t8;
  if ($[13] !== props.disabled || $[14] !== t7) {
    t8 = <Col xs={3} sm={4}><Button className={styles.sendBtn} type="submit" disabled={props.disabled} aria-label={t7}>Send</Button></Col>;
    $[13] = props.disabled;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <Form.Group><Row className="d-flex align-items-center no-wrap">{t6}{t8}</Row></Form.Group>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t0 || $[20] !== t9) {
    t10 = <Form onSubmit={t0}>{t9}</Form>;
    $[19] = t0;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}